import { render, staticRenderFns } from "./CreateItemTemplateView.vue?vue&type=template&id=7f36ffc4&scoped=true&"
import script from "./CreateItemTemplateView.vue?vue&type=script&lang=ts&"
export * from "./CreateItemTemplateView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f36ffc4",
  null
  
)

export default component.exports